var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9878 7.15599C21.9878 6.75216 21.6991 6.42371 21.3459 6.42371H15.0391V7.88693H20.0301L16.7564 10.5913L15.0391 9.18055V11.0368L16.3858 12.1312C16.6047 12.3089 16.9122 12.3089 17.1311 12.1299L20.7041 9.22631V13.0937H15.0391V14.5569H21.3459C21.6991 14.5569 21.9878 14.2298 21.9878 13.8246V7.80482C21.9878 7.78732 21.9864 7.77116 21.9851 7.75367C21.9864 7.73617 21.9878 7.71867 21.9878 7.70251V7.15599Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86618 13.0439C7.78731 13.0439 8.37811 11.827 8.37811 10.0111C8.37811 8.50482 7.94172 6.97833 6.86618 6.97833C5.72887 6.97833 5.30859 8.52502 5.30859 10.0111C5.30859 11.7436 5.85375 13.0439 6.86618 13.0439Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.1809L13.6893 20.1878V-0.142578L0 1.06489V19.1809ZM6.93126 4.75054C9.26899 4.75054 10.8279 6.87471 10.8279 9.9075C10.8279 13.5999 8.84736 15.292 6.80639 15.292C4.57743 15.292 2.86274 13.3535 2.86274 10.0946C2.86408 6.83298 4.48478 4.75054 6.93126 4.75054Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/outlook-icon.2035dd0dd5b9347ae9b0453516f1643d.svg";
export { ForwardRef as ReactComponent };